import SafeUncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { Fragment, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { Question } from 'types';
import { v4 as uuidv4 } from 'uuid';
import CalibrationHistoryItems from 'views/Widgets/Dashboards/TeamDashboard/Calibration/CalibrationHistoryItems';
import { CalibrationHistory } from './utils';

type Props = {
  calibrationHistoryMap: Map<string, CalibrationHistory>;
  question: Question;
};

const PerformanceWrittenResponseCalibrationHistoryLikert: React.FC<Props> = ({
  calibrationHistoryMap,
  question,
}) => {
  const id = useMemo(() => 'calibration-popover-' + uuidv4(), []);
  const entries = Object.entries(calibrationHistoryMap);

  return (
    <>
      <Row className="mt-2 px-0">
        <Col className="text-end">
          <span
            id={id}
            role="button"
            className="py-2 badge rounded-pill bg-warning-soft text-uppercase badge bg-secondary rounded-pill"
          >
            <i className="fe fe-lock me-2"></i>
            <span className="text-primary">
              <FormattedMessage
                id="app.views.person.person_performance.performance_written_response.view_calibration_history"
                defaultMessage="Calibration history"
              />
            </span>
          </span>
        </Col>
      </Row>
      <SafeUncontrolledPopover
        className="popover-variable-lg"
        target={id}
        trigger="hover click"
        placement="right"
      >
        {entries.map(([key, calibrationHistory], index) => (
          <Fragment key={index}>
            {/* @ts-expect-error */}
            <h3>{question.objects.find((it) => it.name === key).value}</h3>
            <CalibrationHistoryItems
              calibrationItems={calibrationHistory.history}
              question={question}
              originalResponses={[
                {
                  value: calibrationHistory.original.value,
                  author: calibrationHistory.original.author,
                  priority: 0,
                },
              ]}
            />
          </Fragment>
        ))}
      </SafeUncontrolledPopover>
    </>
  );
};

export default React.memo(PerformanceWrittenResponseCalibrationHistoryLikert);
